import React, { useState } from "react";

import { Button } from "../ui/button";
import { Input } from "../ui/input";

import { Trash2 } from "lucide-react";

const AddItems = ({ placeholder, value = [], onChange }) => {
  const [itemInput, setItemInput] = useState("");

  const addItem = () => {
    const trimmed = itemInput.trim();
    if (!trimmed) return;

    // Avoid duplicates
    if (value.includes(trimmed)) {
      setItemInput("");
      return;
    }

    onChange([...value, trimmed]);
    setItemInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addItem();
    }
  };

  const removeItem = (item) => {
    onChange(value.filter((i) => i !== item));
  };

  return (
    <div className="w-full">
      <div className="flex gap-3">
        <Input
          placeholder={placeholder}
          value={itemInput}
          onChange={(e) => setItemInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button type="button" onClick={addItem} className="bg-button-coloured">
          + Add
        </Button>
      </div>
      <div className="flex flex-col gap-3 mt-4">
        {value.map((item, i) => (
          <div
            key={i}
            className="border border-grey-3 rounded-lg px-3 py-2 flex justify-between items-center text-grey-primary text-sm shadow-xs"
          >
            <span>{item}</span>
            <Trash2
              className="cursor-pointer text-red-500 w-4 h-4"
              onClick={() => removeItem(item)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddItems;
